class CartDrawerUpsells {
  constructor() {
    // Add-to-cart desde el upsell
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('.cart-upsell__add-form');
      if (!form) return;
      e.preventDefault();
      this.addToCart(form);
    });

   // Render inicial
    this.loadUpsells();

    const self = this;

    // Parche para CADA clase de Dawn que re-renderiza el carrito.
    // 'cart-drawer'  -> open / renderContents (abrir, add)
    // 'cart-items'   -> updateQuantity / onCartUpdate (cambiar cantidad, ELIMINAR)
    const patchTargets = [
      { tag: 'cart-drawer', methods: ['open', 'renderContents'] },
      { tag: 'cart-items', methods: ['updateQuantity', 'onCartUpdate'] },
    ];

    patchTargets.forEach(({ tag, methods }) => {
      customElements.whenDefined(tag).then(() => {
        const Klass = customElements.get(tag);
        if (!Klass || Klass.prototype.__upsellPatched) return;
        Klass.prototype.__upsellPatched = true;

        methods.forEach((fnName) => {
          const original = Klass.prototype[fnName];
          if (typeof original !== 'function') return;
          Klass.prototype[fnName] = function (...args) {
            const result = original.apply(this, args);
            // Promesas (updateQuantity devuelve promesa en algunos casos) y síncronos
            if (result && typeof result.then === 'function') {
              result.then(() => setTimeout(() => self.loadUpsells(), 120));
            } else {
              setTimeout(() => self.loadUpsells(), 120);
            }
            return result;
          };
        });

        self.loadUpsells();
      });
    });

// Red de seguridad: si el upsell queda vacío tras cualquier re-render, lo repuebla.
    const drawerEl = document.querySelector('cart-drawer');
    if (drawerEl && !drawerEl.__upsellObserver) {
      const observer = new MutationObserver(() => {
        const el = document.querySelector('product-recommendations.cart-drawer__upsells');
        if (el && el.dataset.url && !el.querySelector('.cart-upsell__item')) {
          self.loadUpsells();
        }
      });
      observer.observe(drawerEl, { childList: true, subtree: true });
      drawerEl.__upsellObserver = observer;
    }



  }

 loadUpsells() {
    const el = document.querySelector('product-recommendations.cart-drawer__upsells');
    if (!el || !el.dataset.url) return;

    // Forzar intent=related (siempre devuelve resultados, a diferencia de complementary
    // que se vacía cuando el primer producto del carrito no tiene complementarios).
    let url = el.dataset.url;
    url = url.replace(/intent=[^&]*/, 'intent=related');

    fetch(url)
      .then((r) => r.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const incoming = doc.querySelector('.cart-upsell');
        // NO DESTRUCTIVO: solo reemplaza si la respuesta trae productos.
        // Si viene vacía, conserva lo que ya estaba visible.
        if (incoming && incoming.querySelector('.cart-upsell__item')) {
          el.innerHTML = incoming.outerHTML;
        }
      })
      .catch((e) => console.error('[cart-drawer-upsells] load', e));
  }

  sections() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble', selector: '.cart-count-bubble' },
    ];
  }

  async addToCart(form) {
    const btn = form.querySelector('.cart-upsell__add');
    const spinner = form.querySelector('.cart-upsell__spinner');
    const id = form.querySelector('input[name="id"]').value;
    if (btn) btn.setAttribute('disabled', 'disabled');
    if (spinner) spinner.classList.remove('hidden');

    try {
      const res = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          id,
          quantity: 1,
          sections: this.sections().map((s) => s.id),
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      if (data.status) {
        this.reset(btn, spinner);
        return;
      }
      this.renderSections(data.sections);
      const drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.classList.add('active', 'animate');
      this.loadUpsells();
    } catch (err) {
      console.error('[cart-drawer-upsells]', err);
      this.reset(btn, spinner);
    }
  }

  reset(btn, spinner) {
    if (btn) btn.removeAttribute('disabled');
    if (spinner) spinner.classList.add('hidden');
  }

  renderSections(sections) {
    this.sections().forEach((section) => {
      const html = sections && sections[section.id];
      if (!html) return;
      const target = document.querySelector(section.selector);
      if (!target) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const src = parsed.querySelector(section.selector);
      if (src) target.innerHTML = src.innerHTML;
    });
  }
}

if (document.readyState !== 'loading') {
  new CartDrawerUpsells();
} else {
  document.addEventListener('DOMContentLoaded', () => new CartDrawerUpsells());
}